import { createContext, useState, useEffect } from "react";
import axios from "axios";

export const SearchContext = createContext();

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

export const SearchProvider = ({ children }) => {
  const [allData, setAllData] = useState([]);
  const [loadingSearchData, setLoadingSearchData] = useState(true);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const [productsRes, blogsRes] = await Promise.all([
          axios.get(`${BASE_URL}/api/products`),
          axios.get(`${BASE_URL}/api/blogs`),
        ]);

        // --- Enhance data with "type" fields ---
        const products = productsRes.data.map((p) => ({
          ...p,
          itemType: "product",
          category: p.category || "products",
        }));

        const blogs = blogsRes.data.map((b) => ({
          ...b,
          itemType: "blog",
        }));

        // Merge all results into one dataset
        const combined = [...products, ...blogs];

        setAllData(combined);
        setLoadingSearchData(false);
      } catch (error) {
        console.error("Failed to fetch data for search:", error);
        setLoadingSearchData(false);
      }
    };

    fetchAllData();
  }, []);

  return (
    <SearchContext.Provider value={{ allData, loadingSearchData }}>
      {children}
    </SearchContext.Provider>
  );
};
